// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3N4JQ","modalFooterButton":"ModalNotes_modalFooterButton__29tUk"};